var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',{staticClass:"thumbnail",style:(!_vm.fluid ? ("width: " + _vm.size + "px; height: " + _vm.size + "px") : ''),attrs:{"thumbnail":"","src":_vm.theSrc},on:{"error":_vm.handleError}})}
var staticRenderFns = []

export { render, staticRenderFns }